import { useMemo } from 'react'

import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const useDraftMessage = (profileId: number): string | null => {
  const { draftMessages } = useShallowEqualSelector(
    ({ draftMessages: { draftMessages } }) => ({
      draftMessages,
    })
  )

  return useMemo(() => {
    if (draftMessages[profileId]) {
      return draftMessages[profileId]
    }

    return null
  }, [draftMessages, profileId])
}
